app.component("closureTamponade", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/closureTamponade/closureTamponade.html",
	controller: "closureTamponadeController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("closureTamponadeController", [
	"$scope",
	function ($scope) {
		this.$onInit = function () {};

        $scope.finalTamponadeOptions = [
			{ value: "AIR_100", name: "Air 100%" },
			{ value: "FILTERED_AIR_100", name: "Filtered Air 100%" },
			{ value: "SF6_GAS_20", name: "20% SF6 Gas" },
			{ value: "OTHER", name: "Other" },
		];

          $scope.bubbleOptions = [
				{ value: "SIZE_100", name: "100%" },
				{ value: "SIZE_90", name: "90%" },
				{ value: "SIZE_80", name: "80%" },
				{ value: "SIZE_70", name: "70%" },
				{ value: "SIZE_60", name: "60%" },
				{ value: "SIZE_50", name: "50%" },
				{ value: "SIZE_40", name: "40%" },
				{ value: "SIZE_30", name: "30%" },
				{ value: "SIZE_20", name: "20%" },
				{ value: "SIZE_10", name: "10%" },
				{ value: "OTHER", name: "Other" },
			];

     
	},
]);
